import '$lib'

export const ssr = false
export const prerender = false
export const trailingSlash = 'always'
